import {ColorInput, Fieldset, TextInput} from '@mantine/core'
import {WorkweekForm} from '../workweek/WorkweekForm.tsx'
import type {FormValues} from './FormValues.ts'
import type {UseFormReturnType} from '@mantine/form'

type Props = {
  form: UseFormReturnType<FormValues>
  disabled: boolean
}

export const FormFields = ({form, disabled: containerDisabled}: Props) => {
  const disabled = containerDisabled

  return (
    <>
      <Fieldset legend={'General'}>
        <div style={{flex: 1}}>
          <TextInput
            label={'Name'}
            key={form.key('name')}
            {...form.getInputProps('name')}
            style={{minWidth: 325}}
            required
            disabled={disabled}
          />
        </div>
        <ColorInput
          label={'Color'}
          value={form.values.color}
          onChange={(color) => form.setFieldValue('color', color)}
          swatches={[
            '#191919',
            '#868e96',
            '#fa5252',
            '#e64980',
            '#be4bdb',
            '#7950f2',
            '#4c6ef5',
            '#228be6',
            '#15aabf',
            '#12b886',
            '#40c057',
            '#82c91e',
            '#fab005',
            '#fd7e14',
          ]}
          disabled={disabled}
        />
      </Fieldset>

      <Fieldset legend={'Workweek'}>
        <WorkweekForm
          value={form.values.workdays}
          onValueChange={(workdays) => form.setFieldValue('workdays', workdays)}
          disabled={disabled}
        />
      </Fieldset>
    </>
  )
}
